import React from 'react';
import { DeviceType, GetDeviceManager, GetDevices, UserAction } from '../../../containers/rtc/DeviceManagerContext';
import { T, tFunctionType } from 'app/components/localization';
import CallErrorMessage from './CallErrorMessage';

const changeBrowserSettingsMessages = {
  [DeviceType.Audio]: (t: tFunctionType) => ({
    message: t('rtc.device-setup.change-browser-settings.audio.error'),
    action: t('rtc.device-setup.error-actions.show-me-how'),
  }),
  [DeviceType.Video]: (t: tFunctionType) => ({
    message: t('rtc.device-setup.change-browser-settings.video.error'),
    action: t('rtc.device-setup.error-actions.show-me-how'),
  }),
};

const messages: {
  // This type makes sure all actions for all types are covered
  [UA in UserAction]: {
    [DT in DeviceType]: (t: tFunctionType) => ({
      message: string;
      action: string;
    });
  };
} = {
  [UserAction.None]: {
    [DeviceType.Audio]: () => ({ message: '', action: '' }),
    [DeviceType.Video]: () => ({ message: '', action: '' }),
  },
  [UserAction.AskPermission]: {
    [DeviceType.Audio]: (t) => ({
      message: t('rtc.device-setup.initial.audio.error'),
      action: t('rtc.device-setup.error-actions.show-me-how'),
    }),
    [DeviceType.Video]: (t) => ({
      message: t('rtc.device-setup.initial.video.error'),
      action: t('rtc.device-setup.error-actions.show-me-how'),
    }),
  },
  [UserAction.InspectDeviceSettings]: {
    [DeviceType.Audio]: (t) => ({
      message: t('rtc.device-setup.check.audio.error'),
      action: t('rtc.device-setup.error-actions.check'),
    }),
    [DeviceType.Video]: (t) => ({
      message: t('rtc.device-setup.check.video.error'),
      action: t('rtc.device-setup.error-actions.check'),
    }),
  },
  [UserAction.ConnectDevice]: {
    [DeviceType.Audio]: (t) => ({
      message: t('rtc.device-setup.connect.audio.title'),
      action: t('rtc.device-setup.error-actions.resolve'),
    }),
    [DeviceType.Video]: (t) => ({
      message: t('rtc.device-setup.connect.video.title'),
      action: t('rtc.device-setup.error-actions.resolve'),
    }),
  },
  [UserAction.MakeDeviceReadable]: {
    [DeviceType.Audio]: (t) => ({
      message: t('rtc.device-setup.check.audio.error'),
      action: t('rtc.device-setup.error-actions.resolve'),
    }),
    [DeviceType.Video]: (t) => ({
      message: t('rtc.device-setup.check.video.error'),
      action: t('rtc.device-setup.error-actions.resolve'),
    }),
  },
  [UserAction.ChangeBrowserSettings]: changeBrowserSettingsMessages,
  [UserAction.ChangeBrowserSettingsAndRetry]: changeBrowserSettingsMessages,
  [UserAction.ChangeBrowserSettingsAndReload]: changeBrowserSettingsMessages,
};

const DeviceManagerErrorMessage = () =>
  <T>{t =>
    <GetDeviceManager>{(manager) => manager &&
      <GetDevices>{(devices) => {
        if (devices && devices.dismissed && devices.userAction) {
          const type = devices.audio.userAction ? DeviceType.Audio : DeviceType.Video;
          const { message, action } = messages[devices.userAction][type](t);
          return (
            <CallErrorMessage buttonLabel={action} buttonAction={manager.reopen}>
              {message}
            </CallErrorMessage>
          );
        } else {
          return null;
        }
      }}</GetDevices>
    }</GetDeviceManager>
  }</T>;

export default DeviceManagerErrorMessage;
